module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'view_mode',
          value: 'click'
        });
        _vm.sidebarChangePanel('themes')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.on_click')))]), _vm._v(" "), _c('span', {
    staticClass: "box-text"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.on_click_some_button')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/box-click.svg"),
      "alt": ""
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-73ba0b82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/viewmode/Click.vue
 ** module id = 859
 ** module chunks = 1
 **/